import { getFeaturedSites } from '@/mocks/sites';

export default function RecommendedSites() {
  const featuredSites = getFeaturedSites();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            精选推荐网站
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-lg mx-auto">
            编辑团队精心挑选的优质网站，每一款都值得收藏使用
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featuredSites.map((site) => (
            <a
              key={site.id}
              href={site.url}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="group bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6 hover:border-accent-300 hover:shadow-md transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0 transition-transform group-hover:scale-105">
                  <i className={`${site.icon} text-accent-600 text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                      {site.name}
                    </h3>
                    <span className="px-1.5 py-0.5 rounded-md bg-accent-100 text-accent-700 text-[10px] font-medium whitespace-nowrap">
                      推荐
                    </span>
                  </div>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {site.description}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 mt-4 flex-wrap">
                {site.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-2 py-0.5 rounded-md bg-background-100 text-foreground-500 text-[10px] md:text-xs whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}